module.exports = __webpack_public_path__ + "img/新闻默认图.af785fd2.jpg";